var Parse = require('parse').Parse;
angular.module('ikeweb.user').factory('loginService', ['loginTopics', 'pubSubService',

    function login(loginTopics, pubSubService) {

        var User = Parse.User.extend({
            getUnit: function() {
                return this.get('unit');
            },
            setUnit: function(unit) {
                this.set('unit', unit);
                return this;
            },
            getLocale: function() {
                return this.get('locale');
            },
            setLocale: function(locale) {
                this.set('locale', locale);
                return this;
            }
        });

        function login(userObj) {
            var username = userObj.username;
            var password = userObj.password;
            return User.logIn(username, password)
                .then(function(user) {
                    pubSubService.publish(loginTopics.LOGIN.COMPLETED.SUCCESS);
                    return user;
                });
        }

        function logout() {
            User.logOut();
            window.location = '/';
        }

        function getLoggedInUser() {
            return User.current();
        }

        function getLoggedInUserName() {
            return User.current() ? User.current().get('username') : undefined;
        }

        function isLoggedIn() {
            return !!getLoggedInUser();
        }

        function save(user) {
            return user.save();
        }

        function requestPasswordReset(email) {
            return User.requestPasswordReset(email);
        }

        function changePassword(currentPassword, newPassword) {
            var currentUser = User.current();
            var username = currentUser.get('username');
            currentUser.set('password', currentPassword);

            return currentUser.logIn()
                .then(function(user) {
                    user.setPassword(newPassword);
                    return user.save();
                })
                .then(User.logOut)
                .then(function() {
                    return User.logIn(username, newPassword);
                });
        }

        return {
            login: login,
            logout: logout,
            getLoggedInUser: getLoggedInUser,
            isLoggedIn: isLoggedIn,
            save: save,
            requestPasswordReset: requestPasswordReset,
            changePassword: changePassword,
            getLoggedInUserName: getLoggedInUserName
        };
    }
]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'login',
            'changePassword',
            'requestPasswordReset',
            'save'
        ];

        $provide.decorator('loginService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                    101: 'USER_NOT_FOUND'
                });
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('changePassword')
                    .onSuccess(notificationService.success('NOTIFICATION.LOGIN.CHANGE_PASSWORD', 'NOTIFICATION.LOGIN.PASSWORD_CHANGED'))
                    .onError(notificationService.error('NOTIFICATION.LOGIN.CHANGE_PASSWORD', 'NOTIFICATION.LOGIN.CHANGE_PASSWORD_PROBLEM'))
                    .decorate('requestPasswordReset')
                    .onSuccess(notificationService.success('NOTIFICATION.LOGIN.FORGOT_PASSWORD', 'NOTIFICATION.LOGIN.FORGOT_PASSWORD_EMAIL_SENT'))
                    .fork();
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/login/login.service.js
// module id = 467
// module chunks = 0